export default "__VITE_ASSET__CkkZD251__";